export default __webpack_public_path__ + "static/bariol_serif_bold-webfont-e8f94d1867aca8162f62f8684fad04f9.woff";